import styled from 'styled-components';
import media from 'styled-media-query';

export const Container = styled.div`
  width: 100%;
  padding: 0 2.4rem;
  margin-top: 5.6rem;

  ${media.greaterThan('medium')`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: 14rem;
  `}
`;

export const Title = styled.div`
  font-size: 2rem;
  line-height: 2.6rem;
  font-weight: 600;

  ${media.greaterThan('medium')`
    font-size: 4.8rem;
    line-height: 5.4rem;
  `}
`;

export const CardsRow = styled.div`
  ${media.greaterThan('small')`
    display: flex;
    gap: 1rem;
  `}

  ${media.greaterThan('large')`
    display: flex;
    gap: 8rem;
  `}
`;

export const Card = styled.div`
  padding: 1.2rem 1.8rem;
  border: ${({ theme }) => `1px solid ${theme.colors.grayBorder}`};
  border-radius: 1.2rem;
  width: 100%;
  margin: 2.4rem auto;
  display: flex;
  flex-direction: column;
  align-items: center;

  ${media.greaterThan('medium')`
    padding: 4rem 8rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-direction: column;
    margin-bottom: 6rem;
  `}
`;

export const Number = styled.span`
  font-weight: 600;
  font-size: 2rem;
  line-height: 3.2rem;
  color: ${({ theme }) => theme.colors.gray3};
  margin-right: 1.2rem;
`;

export const Text = styled.span`
  font-size: 1.6rem;
  line-height: 3.2rem;
  color: ${({ theme }) => theme.colors.blackText};
  font-weight: 600;
`;
